
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/merch",
      function () {
        return require("private-next-pages/merch.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/merch"])
      });
    }
  